/**
 * Google Analytics 4 Event Tracking Utilities
 * Türkiye için serbest - consent kontrolü yok
 */

// Genel GA4 event gönderme fonksiyonu
export const trackGA4Event = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
    console.log(`[Analytics] Event sent: ${eventName}`, parameters);
  }
};

// ============================================
// HAZIR EVENT FONKSİYONLARI
// ============================================

// WhatsApp tıklaması
export const trackWhatsAppGA4 = (venueName, venueId, source = 'venue_detail') => {
  trackGA4Event('whatsapp_click', {
    venue_name: venueName,
    venue_id: venueId,
    source: source,
    event_category: 'engagement'
  });
};

// Telefon araması
export const trackPhoneCallGA4 = (venueName, venueId, source = 'venue_detail') => {
  trackGA4Event('phone_call', {
    venue_name: venueName,
    venue_id: venueId,
    source: source,
    event_category: 'engagement'
  });
};

// Teklif formu gönderimi
export const trackQuoteRequestGA4 = (venueName, venueId, eventType, packageName = null) => {
  trackGA4Event('quote_request', {
    venue_name: venueName,
    venue_id: venueId,
    event_type: eventType,
    package_name: packageName,
    event_category: 'conversion'
  });
};

// Mekan görüntüleme
export const trackVenueViewGA4 = (venueName, venueId, cityName, districtName) => {
  trackGA4Event('venue_view', {
    venue_name: venueName,
    venue_id: venueId,
    city: cityName,
    district: districtName,
    event_category: 'engagement'
  });
};

// Arama yapma
export const trackSearchGA4 = (searchTerm, cityName, filters = {}) => {
  trackGA4Event('search', {
    search_term: searchTerm,
    city: cityName,
    filters: JSON.stringify(filters),
    event_category: 'engagement'
  });
};

// Favori ekleme
export const trackFavoriteGA4 = (venueName, venueId, action = 'add') => {
  trackGA4Event('favorite', {
    venue_name: venueName,
    venue_id: venueId,
    action: action, // 'add' or 'remove'
    event_category: 'engagement'
  });
};

// Kullanıcı kaydı
export const trackSignUpGA4 = (method = 'email') => {
  trackGA4Event('sign_up', {
    method: method,
    event_category: 'conversion'
  });
};

// Kullanıcı girişi
export const trackLoginGA4 = (method = 'email') => {
  trackGA4Event('login', {
    method: method,
    event_category: 'engagement'
  });
};
